import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './authPopup.css';

const Login = () => {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    username: '',
    password: '',
    remember: false,
  });

  const handleChange = (field, value) => {
    setForm({ ...form, [field]: value });
  };

  const handleLogin = (e) => {
    e.preventDefault();
    navigate('/Home');
  };

  return (
    <main className="authPage">
      <div className="authCard">
        <button className="authCloseBtn" onClick={() => navigate(-1)}>
          ×
        </button>

        <h1>Welcome Back</h1>

        <form onSubmit={handleLogin}>
          <label>
            Username
            <input
              type="text"
              value={form.username}
              onChange={(e) => handleChange('username', e.target.value)}
            />
          </label>

          <label>
            Password
            <input
              type="password"
              value={form.password}
              onChange={(e) => handleChange('password', e.target.value)}
            />
          </label>

          <div className="authOptions">
            <label className="checkLabel">
              <input
                type="checkbox"
                checked={form.remember}
                onChange={(e) => handleChange('remember', e.target.checked)}
              />
              Remember me
            </label>

            <button type="button" className="textBtn">
              Forgot password?
            </button>
          </div>

          <button type="submit" className="authMainBtn">
            Log in
          </button>
        </form>

        <div className="socialDivider">
          <span></span>
          <p>Sign in with</p>
          <span></span>
        </div>

        <div className="socialBtns">
          <button></button>
          <button>G</button>
          <button>f</button>
        </div>

        <p className="authBottomText">
          Don’t have an account?{' '}
          <button onClick={() => navigate('/Signup')}>Sign up</button>
        </p>
      </div>
    </main>
  );
};

export default Login;